import * as React from "react";

import { useMyBagOnThisPage } from "../providers";

import { MyBagItems } from "../my-bag-items";
import { MyBagSummary } from "../my-bag-summary";
import { MyBagRewardsCallout } from "../my-bag-rewards-callout";
import { MyBagPromoCode } from "../my-bag-promo-code";
import { MyBagFreeShippingCalculator } from "../my-bag-free-shipping-calculator";

import { MyBagEmptyState } from "./empty-state";
import { MyBagEmptyPortal } from "./portal-empty";
import { MyBagHasItemsPortal } from "./portal-has-items";
import { MyBagIsNotAVirtualOrderPortal } from "./portal-not-a-virtual";

export const PageMyBag: React.FunctionComponent = () => {
  useMyBagOnThisPage();

  return (
    <section className="main-content my-bag">
      <MyBagEmptyPortal>
        <MyBagEmptyState />
      </MyBagEmptyPortal>

      <MyBagHasItemsPortal>
        <MyBagRewardsCallout />

        <MyBagItems />

        <section className="details">
          <MyBagRewardsCallout />
          <MyBagSummary />
          <MyBagIsNotAVirtualOrderPortal>
            <MyBagPromoCode />
            <MyBagFreeShippingCalculator />
          </MyBagIsNotAVirtualOrderPortal>
        </section>
      </MyBagHasItemsPortal>
    </section>
  );
};
